import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const teamPlanningAPI = createApi({
    reducerPath: "TeamPlanningAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getTeamPlannningList: builder.mutation({
            query: (data) => ({
                url: '/TeamPlanning/GetTeamPlanningWithPagination',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addTeamPlanning:builder.mutation({
            query:(data)=>({
                url:"/TeamPlanning/AddTeamPlanning",
                method:'POST',
                body:transformRequest(data)
            }), 
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteTeamPlanning:builder.mutation({
            query:(id)=>({
                url:`/TeamPlanning/DeleteTeamPlanningById?id=${id}`,
                method:'DELETE',
                body:transformRequest(id)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getTeamPlanningById: builder.query({
            query: (id) => ({
                url:`/TeamPlanning/GetTeamPlanningById?TeamPlanningId=${id}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getPlanningListByUserIdAndProjectId: builder.mutation({
            query: (data) => ({
                url:`/TeamPlanning/GetPlanningListByUserIdAndProjectId`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateTeamPlanning: builder.mutation({
            query: (data) => ({
                url: `/TeamPlanning/UpdateTeamPlanning`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTeamPlanningByTeamId: builder.query({
            query: (id) => ({
                url:`/TeamPlanning/GetTeamPlanningId?TeamId=${id}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllResourcePlanningList:builder.query({
            query:(data)=>({
                url:`/TeamResourcePlanning/GetAllResourcePlanningList?TeamId=${data.teamId}&PlanningId=${data.planningId}`,
                method:'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getUnassignedTeamResource:builder.query({
            query:(data)=>({
                url:`/TeamResourcePlanning/GetUnassignedTeamResource?TeamId=${data.teamId}&PlanningId=${data.planningId}`,
                method:'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        assignedTeamResourceMember:builder.mutation({
            query:(data)=>({
                url:`/TeamResourcePlanning/AssignedTeamResourceMember`,
                method:'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteTeamPlanningTaskById: builder.mutation({
            query: (data) => ({
                url: `/TeamPlanning/DeleteTeamPlanningTaskById`,
                method: 'DELETE',
                body:transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        


    })
})

export const {
  useGetTeamPlannningListMutation,
  useAddTeamPlanningMutation,
  useDeleteTeamPlanningMutation,
  useLazyGetTeamPlanningByIdQuery,
  useUpdateTeamPlanningMutation,
  useGetPlanningListByUserIdAndProjectIdMutation,
  useLazyGetTeamPlanningByTeamIdQuery,
  useLazyGetUnassignedTeamMembersQuery,
  useGetAssignedTeamMembersMutation,
  useAssignedTeamMemberMutation,
  useDeleteUnassignedTeamMembersMutation,
  useLazyGetAllResourcePlanningListQuery,
  useLazyGetUnassignedTeamResourceQuery,
  useAssignedTeamResourceMemberMutation,
  useDeleteTeamPlanningTaskByIdMutation

} = teamPlanningAPI;

export default teamPlanningAPI;